
const nativeTokens = {
	bnb: {
		address: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
		decimals: 18,
		name: "Wrapped BNB",
		symbol: "WBNB",
	},
	matic: {
		address: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
		decimals: 18,
		name: "Wrapped Matic",
		symbol: "WMATIC",
	},
	ftm: {
		address: "0x21be370d5312f44cb42ce377bc9b8a0cef1a4c83",
		decimals: 18,
		name: "Wrapped Fantom",
		symbol: "WFTM",
	},
	eth: {
		address: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
		decimals: 18,
		name: "Wrapped Ether",
		symbol: "WETH",
	},
	ht: {
		address: "0x5545153ccfca01fbd7dd11c0b23ba694d9509a6f",
		decimals: 18,
		name: "Wrapped HT",
		symbol: "WHT",
	},
}

 export const networks = {
	bsc: {
		name: "bsc",
		networkId: 56,
		token: nativeTokens.bnb,
	},
	polygon: {
		name: "polygon",
		networkId: 137,
		token: nativeTokens.matic,
	},
	fantom: {
		name: "fantom",
		networkId: 250,
		token: nativeTokens.ftm,
	},
	ethereum: {
		name: "ethereum",
		networkId: 1,
		token: nativeTokens.eth,
	},
	heco: {
		name: "heco",
		networkId: 128,
		token: nativeTokens.ht,
	},
}


networks.bsc.amms = [
	{
		name: 'Pancakeswap V1',
		router: '0x05ff2b0db69458a0750badebc4f9e13add608c7f',
		factory: '0xBCfCcbde45cE874adCB698cC183deBcF17952812',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Pancakeswap V2',
		router: '0x10ed43c718714eb63d5aa57b78b54704e256024e',
		factory: '0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73',
		chef: '0x73feaa1ee314f8c655e354234017be2193c9e24e',
		timelock: '',
		proof: '',
	},
	{
		name: 'Apeswap',
		router: '0xcF0feBd3f17CEf5b47b0cD257aCf6025c5BFf3b7',
		factory: '0x0841BD0B734E4F5853f0dD8d7Ea041c241fb0Da6',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Sushiswap',
		router: '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506',
		factory: '0xc35DADB65012eC5796536bD9864eD8773aBc74C4',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Biswap',
		router: '0x3a6d8ca21d1cf76f653a67577fa0d27453350dd8',
		factory: '0x858E3312ed3A876947EA49d572A7C42DE08af7EE',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Bakery',
		router: '',
		factory: '0x01bF7C66c6BD861915CdaaE475042d3c4BaE16A7',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Jetswap',
		router: '0xBe65b8f75B9F20f4C522e0067a3887FADa714800',
		factory: '0x0eb58E5c8aA63314ff5547289185cC4583DfCBD5',
		chef: '',
		timelock: '',
		proof: '',	
	},
	{
		name: 'Mdex',
		router: '0x7dae51bd3e3376b8c7c4900e9107f12be3af1ba8',
		factory: '0x3CD1C46068dAEa5Ebb0d3f55F6915B10648062B8',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Safeswap',
		router: '',
		factory: '0x86A859773cf6df9C8117F20b0B950adA84e7644d',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Baby',
		router: '',
		factory: '0x86407bEa2078ea5f5EB5A52B2caA963bC1F889Da',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Fins',
		router: '',
		factory: '0xe759Dd4B9f99392Be64f1050a6A8018f73B53a13',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Cheeseswap',
		router: '',
		factory: '0xdd538E4Fd1b69B7863E1F741213276A6Cf1EfB3B',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Mars',
		router: '',
		factory: '0x6f12482D9869303B998C54D91bCD8bCcba81f3bE',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Global',
		router: '',
		factory: '0xF238d267B3B1C85F2a95354251C20626bb7bc2A1',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Planet',
		router: '',
		factory: '0xa053582601214FEb3778031a002135cbBB7DBa18',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Raraswap',
		router: '',
		factory: '0x9b3fEF64b1Aa1144B04f46F8119F2C51c8fD0D1F',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Cafeswap',
		router: '',
		factory: '0x3e708FdbE3ADA63fc94F8F61811196f1302137AD',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Twindex',
		router: '',
		factory: '0x4E66Fda7820c53C1a2F601F84918C375205Eac3E',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Pantherswap',
		router: '',
		factory: '0x670f55c6284c629c23baE99F585e3f17E8b9FC31',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Leonicorn',
		router: '',
		factory: '0xEB10f4Fe2A57383215646b4aC0Da70F8EDc69D4F',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Coinswap',
		router: '',
		factory: '0xC2D8d27F3196D9989aBf366230a47384010440c0',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Sparkswap',
		router: '',
		factory: '0xC3187EB9AB08eB845A12dA6A93c3Ab8655c5AF80',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Jswap',
		router: '',
		factory: '0xd654CbF99F2907F06c88399AE123606121247D5C',
		chef: '',
		timelock: '',
		proof: '',
	}
]

networks.polygon.amms = [
	{
		name: 'Quickswap',
		router: '0xa5e0829caced8ffdd4de3c43696c57f7d7a678ff',
		factory: '0x5757371414417b8C6CAad45bAeF941aBc7d3Ab32',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Sushiswap',
		router: '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506',
		factory: '0xc35DADB65012eC5796536bD9864eD8773aBc74C4',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Apeswap',
		router: '0xC0788A3aD43d79aa53B09c2EaCc313A787d1d607',
		factory: '0xCf083Be4164828f00cAE704EC15a36D711491284',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Biswap',
		router: '',
		factory: '0x95c6D24c02F1F2cb4C93dBEA8E53D95e12Bc4d47',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Dfyn',
		router: '0xA102072A4C07F06EC3B4900FDC4C7B80b6c57429',
		factory: '0xE7Fb3e833eFE5F9c441105EB65Ef8b261266423B',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Honeyswap',
		router: '0xaD340d0CD0B117B0140671E7cB39770e7675C848',
		factory: '0x03DAa61d8007443a6584e3d8f85105096543C19c',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Waultswap',
		router: '0x3a1d87f206d12415f5b0a33e786967680aab4f6d',
		factory: '0xa98ea6356a316b44bf710d5f9b6b4ea0081409ef',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Jetswap',
		router: '0x5C6EC38fb0e2609672BDf628B1fD605A523E5923',
		factory: '0x668ad0ed2622C62E24f0d5ab6B6Ac1b9D2cD4AC7',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Creampie',
		router: '0xA3415b8F2D3Ef121248362fCf3e4437c21545A68',
		factory: '0xf502b3d87311863bb0ac3cf3d2729a78438116cf',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Polycat',
		router: '',
		factory: '0x477Ce834Ae6b7aB003cCe4BC4d8697763FF456FA',
		chef: '',
		timelock: '',
		proof: '',		
	},
	{
		name: 'Elk liquidity',
		router: '',
		factory: '0xE3BD06c7ac7E1CeB17BdD2E5BA83E40D1515AF2a',
		chef: '',
		timelock: '',
		proof: '',		
	},
	{
		name: 'Tetuswap',
		router: '',
		factory: '0x684d8c187be836171a1Af8D533e4724893031828',
		chef: '',
		timelock: '',
		proof: '',		
	},
	{
		name: 'Polydex',
		router: '',
		factory: '0xEAA98F7b5f7BfbcD1aF14D0efAa9d9e68D82f640',
		chef: '',
		timelock: '',
		proof: '',		
	},
	{
		name: 'Safeswap V2',
		router: '',
		factory: '0x5be44d6C5634161CdaDcC2bc35389325aa493e83',
		chef: '',
		timelock: '',
		proof: '',		
	},
	{
		name: 'Firebird',
		router: '',
		factory: '0x5De74546d3B86C8Df7FEEc30253865e1149818C8',
		chef: '',
		timelock: '',
		proof: '',		
	},
	{
		name: 'Unifi',
		router: '',
		factory: '0x4FEE52912f81B78C3CdcB723728926ED6a893D27',
		chef: '',
		timelock: '',
		proof: '',		
	}
]
	

networks.fantom.amms = [
	{
		name: 'Spiritswap',
		router: '0x16327e3fbdaca3bcf7e38f5af2599d2ddc33ae52',
		factory: '0xEF45d134b73241eDa7703fa787148D9C9F4950b0',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Spookyswap',
		router: '0xf491e7b69e4244ad4002bc14e878a34207e38c29',
		factory: '0x152eE697f2E276fA89E96742e9bB9aB1F2E61bE3',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Sushiswap',
		router: '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506',
		factory: '0xc35DADB65012eC5796536bD9864eD8773aBc74C4',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Hyperswap',
		router: '0x53c153a0df7e050bbefbb70ee9632061f12795fb',
		factory: '0x991152411A7B5A14A8CF0cDDE8439435328070dF',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Morpheus',
		router: '',
		factory: '0x9C454510848906FDDc846607E4baa27Ca999FBB6',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Wakaswap',
		router: '',
		factory: '0xB2435253C71FcA27bE41206EB2793E44e1Df6b6D',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Elk',
		router: '',
		factory: '0x7Ba73c99e6f01a37f3e33854c8F544BbbadD3420',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Dark knight',
		router: '',
		factory: '0x7d82F56ea0820A9d42b01C3C28F1997721732218',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Paint',
		router: '',
		factory: '0x733A9D1585f2d14c77b49d39BC7d7dd14CdA4aa5',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Zoodex',
		router: '',
		factory: '0x6178C3B21F7cA1adD84c16AD35452c85a85F5df4',
		chef: '',
		timelock: '',
		proof: '',
	}
]

networks.ethereum.amms = [
	{
		name: 'Uniswap V2',
		router: '0x7a250d5630b4cf539739df2c5dacb4c659f2488d',
		factory: '0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'SushiSwap',
		router: '0xd9e1ce17f2641f24ae83637ab66a2cca9c378b9f',
		factory: '0xC0AEe478e3658e2610c5F7A4A2E1777cE9e4f2Ac',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'ShibaSwap',
		router: '',
		factory: '0x115934131916C8b277DD010Ee02de363c09d037c',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'CRO Defi',
		router: '',
		factory: '0x9DEB29c9a4c7A88a3C0257393b7f3335338D9A9D',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'TUBE2',
		router: '',
		factory: '0x564C4529E12FB5a48AD609820D37D15800c1f539',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Bestswap',
		router: '',
		factory: '0x10d6b05df2cf388f97C65Ae1442B7736687a2603',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'DaoSwap',
		router: '',
		factory: '0xaCF60B3bd6f6728C0DeB6B6202eC91fb1bfF8F1A',
		chef: '',
		timelock: '',
		proof: '',
	}

]

networks.heco.amms = [
	{
		name: 'Hswap',
		router: '',
		factory: '0xb0b670fc1F7724119963018DB0BfA86aDb22d941',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'DaoSwap',
		router: '',
		factory: '0x2216574F455CCc9E5FF9384Bbbd24e47c569CF67',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'LavaSwap',
		router: '',
		factory: '0x1EA26C17d061E8a7Cc33B20d8d8Dad131d7fb392',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'CircleSwap',
		router: '',
		factory: '0xB49f19289857f4499781AaB9afd4A428C4BE9CA8',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'xFarmer',
		router: '',
		factory: '0x26474955a5Df147e4bF1729C8C1242033f5754df',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Mdis',
		router: '',
		factory: '0x2F3F03b6a1B1d73b01390E234AE813bc06d5B8e8',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Fly',
		router: '',
		factory: '0xF8144d934852d973236BE9851879acF594b41202',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Kikaswap',
		router: '',
		factory: '0x397B4F13FdE52D2FB5543E066E6906c2A56A92b4',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Doge swap',
		router: '',
		factory: '0x0419082bb45f47Fe5c530Ea489e16478819910F3',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Bxh',
		router: '',
		factory: '0xe0367ec2bd4Ba22B1593E4fEFcB91D29DE6C512a',
		chef: '',
		timelock: '',
		proof: '',
	},
	{
		name: 'Airswap',
		router: '',
		factory: '0x22Aa906d38fADF9Cc4C9a74CE3946A9A15A4EF2b',
		chef: '',
		timelock: '',
		proof: '',
	}
]

